import { workerService } from '../../services'

// initial state
const state = () => ({
  workers: [],
  worker: null
})

// actions
const actions = {
  getWorkers({ commit }) {
    workerService.getWorkers()
      .then(
        workers => {
          commit('workersSuccess', workers);
        },
        error => {
          commit('workersFailure', error);
        }
      );
  },
  getWorker({ commit }, workerId) {
    workerService.getWorker(workerId)
      .then(
        worker => {
          commit('workerSuccess', worker);
        },
        error => {
          commit('workerFailure', error);
        }
      );
  },
  createWorker({ commit }, workerData) {
    workerService.createWorker(workerData)
      .then(
        worker => {
          commit('workerSuccess', worker);
        },
        error => {
          commit('workerFailure', error);
        }
      );
  },
  editWorker({ commit }, {workerId, workerData}) {
    workerService.editWorker(workerId, workerData)
      .then(
        worker => {
          commit('workerSuccess', worker);
        },
        error => {
          commit('workerFailure', error);
        }
      );
  },
  deleteWorker({ commit }, workerId) {
    workerService.deleteWorker(workerId)
      .then(
        worker => {
            commit('workerDelete', worker.id);
          },
          error => {
            commit('workerFailure', error);
          }
      );
  },
}

// mutations
const mutations = {
  workersSuccess(state, workers) {
      state.workers = workers
  },
  workersFailure(state, error) {
      console.log(state, error);
  },
  workerSuccess(state, worker) {
      state.worker = worker
  },
  workerFailure(state, error) {
      console.log(state, error);
  },
  workerDelete(state, workerId) {
      let index = state.workers.findIndex(worker => worker.id == workerId);
      state.workers.splice(index, 1);
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
